import { Language } from "@/i18n";
import { CountryCode } from "@/types";

export type LanguageOption = {
  countryCode: CountryCode;
  languageKey: Language;
};

export const useLanguageOptions = () => {
  return [
    { countryCode: "GB", languageKey: "en-GB" },
    { countryCode: "US", languageKey: "en-US" },
    { countryCode: "DE", languageKey: "de-DE" },
    { countryCode: "GR", languageKey: "el-GR" },
    { countryCode: "ES", languageKey: "es-ES" },
    { countryCode: "MX", languageKey: "es-MX" },
    { countryCode: "EE", languageKey: "et-EE" },
    { countryCode: "FR", languageKey: "fr-FR" },
    { countryCode: "IN", languageKey: "hi-IN" },
    { countryCode: "HR", languageKey: "hr-HR" },
    { countryCode: "AM", languageKey: "hy-AM" },
    { countryCode: "IT", languageKey: "it-IT" },
    { countryCode: "JP", languageKey: "ja-JP" },
    { countryCode: "GE", languageKey: "ka-GE" },
    { countryCode: "KR", languageKey: "ko-KR" },
    { countryCode: "LT", languageKey: "lt-LT" },
    { countryCode: "LV", languageKey: "lv-LV" },
    { countryCode: "PL", languageKey: "pl-PL" },
    { countryCode: "PT", languageKey: "pt-PT" },
    { countryCode: "RU", languageKey: "ru-RU" },
    { countryCode: "UA", languageKey: "uk-UA" },
    { countryCode: "CN", languageKey: "zh-CN" },
  ] as LanguageOption[];
};
